export const Data = [
  {
    question: "Can i use my bonus airtime?",
    answer: "Jesus Christ, no !!! 😂",
  },
  {
    question:
      "Would the airtime you recharge be the same exact amount in your wallet?",
    answer:
      "For every airtime deposit you make, you get an equivalent Zeddcoin (ZCN) 100NGN AIRTIME is equal to 1 ZEDD COIN(ZCN) 🔥",
  },
  {
    question: "What is ZCN / zedd coin?",
    answer:
      "ZEDD COIN(ZCN) is Zeddpays currency , your deposits are converted to zeddcoin and you make purchases with it too ❤️",
  },
  {
    question: "What can i purchase with ZCN?",
    answer: "Currently you can purchase 100 Items on Zeddpay with ZCN 🤯",
  },
  {
    question: "VPN, Urgh how , why ?? 😤",
    answer:
      "You DONT need a VPN to use Zeddpay, how ever most purchases on zeddpay are US items that are not offered in Nigeria, once you purchase you will get a reedem code registered in the United states, to use this code on a service like spotify, you will have to turn on a VPN(which hides your current location) then you can change your location to the United states, after that, turn off your VPN and you can proceed ✨",
  },
  {
    question: "I am stuck 😭 , what should i do ?",
    answer: "calm down, we got you! tweet at us @zeddpay ✨",
  },
  {
    question: "To Change your MTN Share PIN",
    answer:
      "Send an SMS with your Default PIN & New PIN & New PIN to 777. For example, send an SMS with ‘0000 1234 1234’ to 777. You can also change your PIN by dialing 777*Default PIN*New PIN New PIN# on your phone and then click on send/press ok. For example, dial *777*0000*1234*1234# and then send/OK.",
  },
  {
    question: "To Change your Glo Share PIN",
    answer:
      "As a new Glo User, your default transfer PIN is 00000. To change this default PIN, dial 132*00000[New PIN][New PIN]#. Example: when you intend to change your default pin and you want your new PIN to be 33222, then dial *132*00000*33222*33222. Once done your default pin will be reset to the new PIN.",
  },
  {
    question: "To Change your Airtel Share PIN",
    answer:
      "The default PIN is used if this is your first time to transfer credit on Airtel. You can change the default pin by sending a text in the following format to 432: PIN 5555 to 432, E.g., to change the password to 4321, the text sent will read — PIN 1234 4321 to 432. You will then receive an SMS confirmation from 432.",
  },
  {
    question: "To Change your 9mobile Share PIN",
    answer:
      "kindly dial 247 old pin* and new pin#. For example *247*0000*2222# and press “send”. To change your Etisalat/9mobile transfer pin is quite similar to the airtime method, dial the following combination *247*old pin*new pin# and send.",
  },
];
